const initTabs = ($tabs = $('.js-tabs')) => {
    const $tabsNav = $tabs.find('.tabs__nav a');
    const activeTabClass = 'is-current';

    $tabsNav.on('click', function(event) {
        const $tabLink = $(this);
        const $targetTab = $($tabLink.attr('href'));

        $tabLink
            .parent()
            .add($targetTab)
            .addClass(activeTabClass)
                .siblings()
                .removeClass(activeTabClass);

        event.preventDefault();
    });
}

initTabs();
